import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpContext } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, shareReplay, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BypassInterceptorContext } from '../interceptors/http.interceptor';
import { accessType } from '../types/response/teams.response.type';

@Injectable({
  providedIn: 'root',
})
export class MenuAccessService {
    private destroy$ = new Subject<void>();
    private menuAccessList$?: Observable<accessType[]>;

    constructor(private http: HttpClient) {}

    fetchMenuAccess(): Observable<accessType[]> {
        if (this.menuAccessList$) {
            return this.menuAccessList$;
        }
        const baseUrl = environment.SWITCH_URL;
        const endPoint = '/user/api/v1/team/access';
        const apiUrl = baseUrl + endPoint;

        const token = localStorage.getItem('auth-token') || '';
        const headers = new HttpHeaders({
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        });

        const context = new HttpContext().set(BypassInterceptorContext, true);

        this.menuAccessList$ = this.http.get<{ data: accessType[] }>(apiUrl, { headers, context }).pipe(
          map((res) => res.data ?? []),
          shareReplay(1),
          takeUntil(this.destroy$)
        );

      return this.menuAccessList$;
    }

    clearCache(): void {
        this.menuAccessList$ = undefined;
    }

    destroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  }
